import React, { useState, useEffect } from "react";
import axios from "axios";
import { Navbar } from "../componentes/navbar";
import { CardComponent } from "../componentes/cardComponent";
import { Form, Space, Row, Col, Button, Switch } from "antd";
import { InputCustom } from "../componentes/inputComponent";
import { TablaCompleta } from "../tablas/tabla_simple";
import { FaRegEdit, FaRegTrashAlt } from "react-icons/fa";
import { manejarError } from "../manejo_errores";
import Swal from "sweetalert2";
import { BotonPrincipal } from "../componentes/btnPrincipal";
import withReactContent from "sweetalert2-react-content";
import { HeadersAuth, traerDatosObjeto } from "../funciones_utiles";
import { SelectCustom } from "../componentes/selectComponent";
import { FileImageOutlined } from '@ant-design/icons';
import { SelectCustomPublicidad } from "../componentes/selectComponentPublicidad";

export const Publicidades = ({ sesion, setAlerta }) => {
  const manejarAlertas = (tipo, mensaje) => {
    setAlerta({ message: mensaje, type: tipo });
  };
  const MySwal = withReactContent(Swal);
  const [tempDatosFormulario, setTempDatosFormulario] = useState({
    id_asociacion: "",
    imagen: []
  });
  const [asociacion, setAsociacion] = useState([]);
  const [idAsociacion, setIdAsociacion] = useState([]);
  const [idPublicidad, setIdPublicidad] = useState();
  const [publicidad, setPublicidad] = useState([]);
  const [mostrarFormularioPublicidad, setMostrarFormularioPublicidad] = useState(false);
  const [mostrarBotonLimpiar, setMostrarBotonLimpiar] = useState(false);
  const [previewImage, setPreviewImage] = useState([]);
  const [refresh, setRefresh] = useState("");
  const [imagenesSeleccionadas, setImagenesSeleccionadas] = useState([]);
  const [modoEdicion, setModoEdicion] = useState(false);

  const guardarPublicidad = async () => {
    // e.preventDefault();
    try {
      let url = idPublicidad
        ? `${process.env.REACT_APP_DOMINIO}/publicidad/${idPublicidad}` // Para actualización
        : `${process.env.REACT_APP_DOMINIO}/publicidad-asociacion`; // Para creación
      let response;
      // console.log("DATA A ENVIAR", tempDatosFormulario);

      if (idPublicidad) {
        // console.log("DATA A ENVIAR", tempDatosFormulario);
        response = await axios.put(url, tempDatosFormulario, HeadersAuth); // Actualización
      } else {
        // console.log(tempDatosFormulario.imagen.slice(0, 30));
        response = await axios.post(url, tempDatosFormulario, HeadersAuth); // Creación
      }
      if (response.status === 200) {
        manejarAlertas("success", "Guardado exitoso");

        setTempDatosFormulario({
          id_asociacion: "",
          imagen: "",
        });

        // Ocultar elementos
        setPreviewImage("");
        setMostrarFormularioPublicidad(false);
        setMostrarBotonLimpiar(false);
        setIdPublicidad(null); // Resetea el ID único
        setRefresh(Date.now()); // Refresca la tabla o lista
        fetchPublicidades();
      }
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };

  const mostrarFormularioHandler = () => {
    setMostrarFormularioPublicidad(true)
	};

  useEffect(() => {
    fetchAsociaciones();
    fetchPublicidades();
  }, [sesion])

  const fetchAsociaciones = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_DOMINIO}/admin/asociaciones`);

      if (response.status == 200) {
        setAsociacion(response.data)
        setIdAsociacion(response.data.map((asoc) => ({
          id: asoc.id
        })))
        // console.log("asoc", response.data)
        // setTempDatosFormulario({
        //   id_asociacion: response.data.id_asociacion || "",
        //   imagen: response.data.imagen || ""
        // })
      }
    } catch (error) {
      console.error("ERROR. No se pudieron obtener las publicidades.", error)
    }
  };

  const fetchPublicidades = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_DOMINIO}/publicidad`);

      if (response.status == 200) {
        setPublicidad(response.data)
        // console.log("publi", response.data)
      }
    } catch (error) {
      console.error("ERROR. No se pudieron obtener las publicidades.", error)
    }
  };

  const convertirArchivoABase64 = (archivo) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(archivo);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };


  const handleEdit = async (id) => {
    try {
      const URI_PUBLICIDAD = process.env.REACT_APP_DOMINIO + "/publicidad/" + id;
      const datosPublicidad = (await traerDatosObjeto(URI_PUBLICIDAD))[0];

      // Setea primero el ID para que el useEffect lo dispare
      setIdPublicidad(id);

      // Seteá los campos mínimos
      setTempDatosFormulario((prev) => ({
        ...prev,
        id_asociacion: Number(datosPublicidad.id_asociacion),
      }));

      if (datosPublicidad.imagen) {
        setPreviewImage([
          `${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${datosPublicidad.id_asociacion}/IMAGENES/PUBLICIDAD/${datosPublicidad.imagen}`,
        ]);
      } else {
        setPreviewImage([]);
      }

      setMostrarFormularioPublicidad(true);
      setMostrarBotonLimpiar(true);
      fetchPublicidades();
      setModoEdicion(true);
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };

  const handleArchivoChange = async (e) => {
    const archivos = Array.from(e.target.files);

    // ⚠️ Si estás editando y hay más de 1 archivo, mostrar warning y cortar
    if (modoEdicion && archivos.length > 1) {
      manejarAlertas("warning", "Solo podés subir una imagen por publicidad al editar.");
      return;
    }

    // ✅ Si estás editando, solo tomar una imagen
    const archivosFiltrados = modoEdicion ? archivos.slice(0, 1) : archivos;

    const imagenesBase64 = await Promise.all(
      archivosFiltrados.map((archivo) => convertirArchivoABase64(archivo))
    );

    if (modoEdicion) {
      // Reemplazar la imagen única
      setImagenesSeleccionadas(archivosFiltrados);
      setPreviewImage(imagenesBase64);
      setTempDatosFormulario((prev) => ({
        ...prev,
        imagen: imagenesBase64,
      }));
    } else {
      // Acumular imágenes si es nueva publicidad
      setImagenesSeleccionadas((prev) => [...prev, ...archivosFiltrados]);
      setPreviewImage((prev) => [...prev, ...imagenesBase64]);
      setTempDatosFormulario((prev) => ({
        ...prev,
        imagen: [...(prev.imagen || []), ...imagenesBase64],
      }));
    }
  };


  const handleEliminar = (id) => {
		MySwal.fire({
			title: "¿Estás seguro?",
			text: "Esta acción no se puede deshacer.",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Sí, eliminar",
			cancelButtonText: "Cancelar",
		}).then(async (result) => {
			if (result.isConfirmed) {
				try {
					const response = await axios.delete(
						`${process.env.REACT_APP_DOMINIO}/publicidad/${id}`,
						HeadersAuth
					);
					if (response.status === 200) {

						manejarAlertas("success", "La publicidad ha sido eliminada.")

						setRefresh(Date.now()); // Actualiza la tabla
            fetchPublicidades();
					}
				} catch (error) {
					manejarAlertas("error", manejarError(error))

				}
			}
		});
	};

  const abrirModalImagen = async (id) => {
    try {
      MySwal.fire({
        title: "Cargando...",
        html: '<div style="text-align:center"><i class="fa fa-spinner fa-spin fa-3x"></i></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
      });

      const response = await axios.get(`${process.env.REACT_APP_DOMINIO}/publicidad/${id}`);
      // console.log("log", response.data);

      const imagen = response.data[0]?.imagen;

      if (!imagen) {
        MySwal.fire({
          icon: "info",
          title: "Sin imágenes",
          text: "No hay imágenes para mostrar.",
        });
        return;
      }

      const imageHtml = `
        <img
          src="${process.env.REACT_APP_DOMINIO_ARCHIVOS}/${response.data[0].id_asociacion}/IMAGENES/PUBLICIDAD/${imagen}"
          alt="imagen-publicidad"
          style="width: 100%; max-width: 500px; object-fit: contain; border-radius: 8px; border: 1px solid #ddd;"
        />
      `;

      MySwal.fire({
        title: "Vista previa de la publicidad",
        html: `<div style="text-align: center;">${imageHtml}</div>`,
        confirmButtonText: "Cerrar",
      });
    } catch (error) {
      console.error("Error al cargar la imagen:", error);
      manejarAlertas("error", "No se pudo cargar la imagen.");
    }
  };

  const eliminarImagen = (index) => {
    const nuevasPreview = previewImage.filter((_, i) => i !== index);
    const nuevasSeleccionadas = imagenesSeleccionadas.filter((_, i) => i !== index);

    setPreviewImage(nuevasPreview);
    setImagenesSeleccionadas(nuevasSeleccionadas);

    setTempDatosFormulario((prev) => ({
      ...prev,
      imagen: nuevasPreview,
    }));
  };





  const traerDatosObjeto = async (url) => {
    try {
      // console.log("url", url)
      const response = await axios.get(url, HeadersAuth);
      if (response.status === 200) {
        return response.data;
      } else {
        console.error("Error al obtener datos:", response.statusText);
        manejarAlertas("error", "Error al obtener los datos.");
        return null;
      }
    } catch (error) {
      manejarAlertas("error", manejarError(error));
    }
  };

  const limpiarCampos = () => {
    setTempDatosFormulario({
      id_asociacion: "",
      imagen: []
    });
    setIdPublicidad(null);
    setPreviewImage("");
    setMostrarBotonLimpiar(false);
    setModoEdicion(false);
  };

  const handleChangeSelect = (value) => {
    setTempDatosFormulario((prev) => ({
      ...prev,
      id_asociacion: value,
    }));
  };


  const elScroll = { x: 0 };
	const columns = [
		{
			title: "ASOCIACIÓN",
			key: "asociacion",
			align: "center",
			sorter: (a, b) => a.asociacion.nombre.localeCompare(b.asociacion.nombre),
			render: (a) => <span>{a.asociacion.nombre}</span>,
		},
		{
			title: "OPCIONES",
			key: "opciones",
			align: "center",
			render: (_, record) => (
				<div style={{ display: "flex", gap: "10px" }}>
					<FaRegEdit
						style={{ cursor: "pointer", color: "blue" }}
						onClick={() => handleEdit(record.id)}
					/>
					<FaRegTrashAlt
						style={{ cursor: "pointer", color: "red" }}
						onClick={() => handleEliminar(record.id)}
					/>
					<FileImageOutlined
						style={{ cursor: "pointer", color: "green" }}
						onClick={() => abrirModalImagen(record.id)}
					/>
				</div>
			),
		},
	];

  // console.log("pre", previewImage)
  return (
    <>
      {/* Título-Pilotos*/}
      <section
        id="seccionPiloto"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "1em",
        }}
      >
        <h1 className="titulos">Gestión de publicidades</h1>
      </section>

      {/* Formulario de publicidades */}
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {/* Contenedor principal para ambos formularios */}
        <div
          style={{
            width: "100%",
            maxWidth: "1200px",
            padding: "20px",
            margin: "0 auto",
          }}
        >
          {/* Botón Limpiar */}

          {/* Primer Formulario: Gestión de Publicidades */}
          {mostrarFormularioPublicidad && (
            <Form onFinish={guardarPublicidad}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: "1em",
                }}
              >
                {" "}
                <h1 className="titulos-secundarios">Datos de publicidad</h1>
                {mostrarBotonLimpiar && (
                  <BotonPrincipal
                    texto="Nueva publicidad"
                    onClick={limpiarCampos}
                  />
                )}
              </div>

              <hr></hr>
              <Row className="rowPublicidad" gutter={16} align="middle" justify="center">
                {/* Select de Asociación */}
                <Col xs={24} sm={8} style={{ width: "100%" }}>
                  <Form.Item
                    style={{ width: "100%" }}
                  >
                    <SelectCustomPublicidad
                      idCampo={"id_asociacion"}
                      nombreCampo={"Asociación"}
                      elPlaceholder={"Seleccioná una asociación"}
                      arrayOpciones={asociacion.length > 0 ? asociacion : []}
                      textoOpciones={"nombre"}
                      required={true}
                      onChange={handleChangeSelect}
                      elValue={tempDatosFormulario.id_asociacion || ""}
                    />
                  </Form.Item>
                </Col>

                {/* Subida de imágenes */}
                {modoEdicion && previewImage.length > 0 ? null : (
                  <Col xs={24} sm={8}
                    style={{ width: "100%" }}
                  >
                  <Form.Item
                    style={{
                      width: "100%",
                    }}>
                    <div
                      style={{
                        width: "100%",
                      }}>
                      {/* Botón personalizado */}
                      <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
                        <label
                          htmlFor="image-upload"
                          style={{
                            display: "flex",
                            height: 30,
                            width: "100%",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#223463",
                            color: "#fff",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "16px",
                            border: "none",
                            outline: "none",
                            transition: "background-color 0.3s ease",
                            marginTop: "1.3em",
                            padding: "0 10px",
                          }}>
                          <span style={{ marginRight: "10px" }}>↑</span>
                          <span
                            style={{
                              height: "30px",
                              width: "0.5px",
                              backgroundColor: "#fff",
                              margin: "0 10px",
                            }}></span>
                          Subir publicidades
                        </label>
                        <input
                          id="image-upload"
                          type="file"
                          multiple={!modoEdicion}
                          accept="image/png, image/jpeg, image/jpg"
                          onChange={handleArchivoChange}
                          style={{ display: "none" }}
                        />
                      </div>
                    </div>
                  </Form.Item>
                </Col>
                )}
              </Row>
              <Row>
                {previewImage && previewImage.length > 0 && (
                  <div
                    style={{
                      width: "100%",
                      background: "#f5f5f5",
                      padding: "1em",
                      borderRadius: "8px",
                      border: "1px solid #d9d9d9",
                    }}>
                    <p style={{ fontWeight: "bold", marginBottom: "0.5em" }}>
                      Imágenes cargadas: {previewImage.length}
                    </p>

                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(auto-fill, minmax(100px, 1fr))",
                        gap: "10px",
                      }}>
                      {previewImage.map((img, index) => (
                        <div
                          key={index}
                          style={{
                            position: "relative",
                            width: "100%",
                            height: "100px",
                            borderRadius: "8px",
                            overflow: "hidden",
                            border: "1px solid #ddd",
                          }}>
                          <img
                            src={img}
                            alt={`Vista previa ${index}`}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                          <button
                            onClick={() => eliminarImagen(index)}
                            style={{
                              position: "absolute",
                              top: "4px",
                              right: "4px",
                              backgroundColor: "rgba(0,0,0,0.6)",
                              border: "none",
                              color: "#fff",
                              borderRadius: "50%",
                              width: "20px",
                              height: "20px",
                              fontSize: "14px",
                              lineHeight: "20px",
                              textAlign: "center",
                              cursor: "pointer",
                            }}
                            title="Eliminar imagen">
                            ×
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </Row>
              <Row gutter={16} style={{ marginTop: "1em" }}>
                {/* Botón guardar/actualizar */}
                <Col
                  xs={24}
                  sm={8}
                  className="botonesResponsive"
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    height: "100%",
                    alignSelf: "flex-start",
                    marginBottom: 5
                  }}>
                  <Button
                    type="primary"
                    className="boton-principal"
                    onClick={guardarPublicidad}>
                    {idPublicidad ? "Actualizar" : "Guardar"}
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </div>
      </section>
      {/* Tabla de asociaciones */}
			<div
				className="botonDescargar"
				style={{
					display: "flex",
					flexDirection: "column",
					flexWrap: "wrap",
					alignContent: "center",
					justifyContent: "center",
					alignItems: "flex-end",
				}}
			>
				<TablaCompleta
					elScroll={elScroll}
					columns={columns}
					fetchDatos={publicidad.length > 0 ? publicidad : []}
					rowKey={"id"}
					mostrarBoton={false}
					gestionTabla={
						<Row style={{ gap: "10px" }}>
							{!mostrarFormularioPublicidad && (
								<BotonPrincipal
									texto="Agregar publicidad"
									onClick={mostrarFormularioHandler}
								/>
							)}
						</Row>
					}
				/>
			</div>
    </>
  )
}